// FileAccessDisplay.jsx
import PropTypes from 'prop-types';
import { ReactComponent as NoAccess } from '../../../assets/icons/no-access.svg';
import { ReactComponent as NoAccessWhite } from '../../../assets/icons/no-access-white.svg';
import { ReactComponent as RequestInprogress } from '../../../assets/icons/ongoing.svg';
import { ReactComponent as RequestInprogressWhite } from '../../../assets/icons/ongoing-white.svg';
import { ReactComponent as AccessGranted } from '../../../assets/icons/successful.svg';
import { ReactComponent as AccessGrantedWhite } from '../../../assets/icons/successful-white.svg';
import { Flex, Typography } from 'antd';
import Icon from '@ant-design/icons';
import { useTheme } from '../../../context/ThemeContext';
import { DARK, FILE_ACCESS_STATUS } from '../../../utilities/constants';
import { ReactComponent as DarkRightIcon } from '../../../assets/icons/right-arrow.svg';
import { ReactComponent as LightRightIcon } from '../../../assets/icons/right-arrow-light.svg';

const { Text } = Typography;

export const FileAccessDisplay = ({
  access_status,
  data,
  onClick,
  icon: IconComponent,
  isClickable = true,
  text: customText,
  component = '',
  showActionRightIcon = true,
  expanded = false,
}) => {
  const { theme } = useTheme();
  const requestInprogressIcon =
    theme === DARK ? RequestInprogress : RequestInprogressWhite;
  const accessGrantedIcon = theme === DARK ? AccessGranted : AccessGrantedWhite;
  const noAccessIcon = theme === DARK ? NoAccess : NoAccessWhite;

  const getFileAccessStatusIcon = status => {
    if (
      status === FILE_ACCESS_STATUS.UNAVAILABLE ||
      status === FILE_ACCESS_STATUS.CLOSED
    ) {
      return noAccessIcon;
    } else if (status === FILE_ACCESS_STATUS.PENDING_APPROVAL) {
      return requestInprogressIcon;
    } else if (status === FILE_ACCESS_STATUS.APPROVED) {
      return accessGrantedIcon;
    }
  };

  const getFileAccessStatusText = (access_status, data) => {
    if (customText) return customText;

    if (access_status === FILE_ACCESS_STATUS.UNAVAILABLE) {
      return 'Video not available';
    }
    if (access_status === FILE_ACCESS_STATUS.PENDING_APPROVAL) {
      return component === 'dms' ? 'Upload in progress' : 'Pending approval';
    }
    if (access_status === FILE_ACCESS_STATUS.APPROVED) {
      return 'View file';
    }
    if (access_status === FILE_ACCESS_STATUS.CLOSED) {
      return data?.error_code === null
        ? component === 'dms'
          ? 'Video not available'
          : 'Request access'
        : 'Retrieval failed';
    }
  };

  return (
    <Flex
      justify="space-between"
      gap={20}
      onClick={isClickable ? onClick : undefined}
      style={{
        cursor: isClickable ? 'pointer' : 'no-drop',
      }}
    >
      <Flex gap={8}>
        {IconComponent && (
          <Icon component={IconComponent} className="status-icon" />
        )}
        <Text>{getFileAccessStatusText(access_status, data)}</Text>
      </Flex>
      <Flex gap={12}>
        <Icon
          component={getFileAccessStatusIcon(access_status)}
          className="status-icon"
        />
        {showActionRightIcon && (
          <Icon
            component={
              expanded
                ? LightRightIcon
                : theme === DARK
                  ? DarkRightIcon
                  : LightRightIcon
            }
          />
        )}
      </Flex>
    </Flex>
  );
};

FileAccessDisplay.propTypes = {
  access_status: PropTypes.string,
  data: PropTypes.shape({
    error_code: PropTypes.string,
  }),
  onClick: PropTypes.func,
  icon: PropTypes.elementType,
  isClickable: PropTypes.bool,
  text: PropTypes.string,
  component: PropTypes.string,
  showActionRightIcon: PropTypes.bool,
};
